export const formStringMatching = (form, fieldName, message) => ({
  validator(field, value) {
    try {
      if (!value || form.getFieldValue(fieldName) === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('error'));
    } catch (e) {
      return Promise.reject(new Error('error'));
    }
  },
  message: message,
});

export const formPhoneRegex = async (field, value) => {
  try {
    const phoneNumber = value?.replaceAll(' ', '')?.replaceAll('(', '')?.replaceAll(')', '');
    const phoneRegex = /^\+905(0[1-5-6-7]|\d\d)\d{3}\d{2}\d{2}$/;

    const phoneWithAreaNumber = phoneNumber.includes('+90') ? phoneNumber : `+90${phoneNumber}`;

    if (!phoneNumber || phoneRegex.test(phoneWithAreaNumber)) {
      return Promise.resolve();
    }

    return Promise.reject(new Error('error'));
  } catch (e) {
    return Promise.reject(new Error('error'));
  }
};

export const formMailRegex = async (field, value) => {
  try {
    const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!value || regex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error());
  } catch (e) {
    return Promise.reject(new Error());
  }
};

export const formCreditCardRegex = async (field, value) => {
  try {
    // Skip validation when there is no value
    if (!value) {
      return value;
    }

    const cleanedValue = value.replaceAll('-', '');

    // AMEX kartları için regex (34 veya 37 ile başlar ve 15 hanelidir)
    const amexRegex = /^3[47]\d{13}$/;

    // Diğer kartlar için regex (16 haneli)
    const otherCardsRegex = /^(?:4\d{12}(?:\d{3})?|[25][1-7]\d{14}|6(?:011|5\d\d)\d{12}|3[47]\d{13}|3(?:0[0-5]|[68]\d)\d{11}|(?:2131|1800|35\d{3})\d{11}|9792\d{12})$/;
   

    if (!cleanedValue || amexRegex.test(cleanedValue) || otherCardsRegex.test(cleanedValue)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error());
  } catch (e) {
    return Promise.reject(new Error());
  }
};

export const formIbanNoRegex = async (field, value) => {
  try {
    const ibanRegex = /^TR\d{2}[-]\d{4}[-]\d{4}[-]\d{4}[-]\d{4}[-]\d{4}[-]\d{2}$/;
    if (!value || ibanRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error());
  } catch (e) {
    return Promise.reject(new Error());
  }
};

const rule = {
  formStringMatching,
  formPhoneRegex,
  formMailRegex,
  formCreditCardRegex,
  formIbanNoRegex,
};

export default rule;
